<template>
  <v-app>
    <div id="app">
      <v-container fluid>
        <router-view />
      </v-container>
    </div>
  </v-app>
</template>

<script>
export default {
  name: 'NoNav'
}
</script>
<style lang="scss" scoped>
body,
html {
  height: 100%;
  height: 100vh;
  background-color: #335b98;
  margin: 0;
  padding: 0;
}
#app {
  background-color: #335b98;
  height: 100vh;
  margin: 0;
  padding: 0;
}
</style>
